import { render, staticRenderFns } from "./coupon-pkg-add.vue?vue&type=template&id=104bf4ac&scoped=true"
import script from "./coupon-pkg-add.vue?vue&type=script&lang=js"
export * from "./coupon-pkg-add.vue?vue&type=script&lang=js"
import style0 from "./coupon-pkg-add.vue?vue&type=style&index=0&id=104bf4ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104bf4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104bf4ac')) {
      api.createRecord('104bf4ac', component.options)
    } else {
      api.reload('104bf4ac', component.options)
    }
    module.hot.accept("./coupon-pkg-add.vue?vue&type=template&id=104bf4ac&scoped=true", function () {
      api.rerender('104bf4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/coupon/coupon-pkg-add.vue"
export default component.exports